const grillaBusquedaPQState = {
  modalEditarPaquete: false,
  openModal: false,
  openModalCaracteristicas: false,
  openModalEditarPrestacion: false,
  openModalDetalle: false,
  observacion: '',
  idPaqueteEditar: 0,
  paqueteEditar: {},
  paqueteEditarMod: {},
  idPaqueteObservacion: 0,
  observacionesGuardadas: [],
  caracteristicasPaquete: [],
  caracteristicasPaqueteMod: [],
  caracteristicasPaqueteEliminar: [],
  caracteristicasPaqueteEditar: [],
  caracteristicasPaqueteAdd: [],
  prestacionesSeleccionadasPQ: [],
  detallePaqueteMod: [],
  detallePaquete: [],
  totalClinica: 0,
  totalHMQ: 0,
  totalMonto: 0,
  detalle: {
    tipoAtencion: "",
    codIsapre: "",
    codPrestador: "",
    glosa: "",
    imed: "",
    codProf: "",
    cantidad: "",
    medHot: "",
    unidad: "",
    monto: "",
    rutBono: "",
    index: "",
  },
  finVigenciaArancelErr: "",
};

export default grillaBusquedaPQState;




// WEBPACK FOOTER //
// ./src/components/Paquetes/GrillaBusquedaPQ/state.js